import _Select from 'react-select'
import _SelectAsync from 'react-select/async'

export type Option = { value: string, label: string }

type SelectProps = { async?: boolean } & (React.ComponentProps<typeof _SelectAsync> | React.ComponentProps<typeof _Select>)

export default function Select({ async = false, value, className = '', ...props }: SelectProps): JSX.Element {
  className = `react-select ${className}`

  if (value) {
    className += ' react-select-has-value'
  }

  return async ? (
    <_SelectAsync
      className={className}
      classNamePrefix="react-select"
      value={value}
      {...props}
    />
  ) : (
    <_Select className={className} classNamePrefix="react-select" value={value} {...props} />
  )
}
